<template>
  <div class="view-wrapper content flex-ui">
    <van-nav-bar title="订单确认" left-arrow @click-left="$router.go(-1)" />
    <div class="grow">
      <div class="scroll-content scroll-content-with-footer">
        <div class="address-box" @click="choiseAddress" v-if="product.ProType === 1 && expressType === 1">
          <div class="info">
            <div v-if="orderData.AddressId <= 0">
              <span class="gray">选择地址</span>
            </div>
            <div v-else>
              <div style="margin-bottom:5px;">
                <span class="name">{{ orderData.Name }} {{ orderData.Mobile }}</span>
              </div>
              <div class="addr">{{ orderData.Address }}</div>
            </div>
          </div>
          <div class="arrow">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="section-group">
          <div class="goods-box">
            <div class="image">
              <img :src="product.ProImage" alt />
            </div>
            <div class="info">
              <div class="info-item">
                <div class="info-item-left">
                  <span class="p-title">{{ product.ProName }}</span>
                </div>
                <div class="info-item-right">
                  <span class="p-price">￥{{ goods.skuPrice }}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-item-left">
                  <span class="sku-f">{{ goods.skuName }}</span>
                </div>
                <div class="info-item-right">
                  <span class="sku-f">x {{ goods.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <van-cell-group>
            <van-cell v-if="orderData.AddressId > 0" title="运费" :value="'￥' + orderData.ExpressFee" />
            <van-cell>
              <template slot="title">
                <span class="red">小计</span>
              </template>
              <span class="red">￥{{ sumPrice }}</span>
            </van-cell>
          </van-cell-group>
        </div>
        <div class="section-group" v-if="product.ProType === 1 && product.SelfPickup">
          <div class="section-group-title">配送方式</div>
          <van-cell-group>
            <div class="gp-content">
              <van-radio-group v-model="expressType" direction="horizontal">
                <van-radio :name="1" checked-color="#ee0a24">快递</van-radio>
                <van-radio :name="2" checked-color="#ee0a24">门店自提</van-radio>
              </van-radio-group>

              <div v-if="expressType === 2" style="margin-top:10px;">
                <p>自提地址：北京市东城区北池子大街67号大眼睛票务</p>
                <p>自提时间：工作日 10:00 - 16:00</p>
              </div>
            </div>
          </van-cell-group>
        </div>
        <div class="section-group" v-if="product.EnableInvoice">
          <van-cell-group>
            <van-switch-cell v-model="orderData.IsInvoice" title="是否开发票" />
          </van-cell-group>
        </div>
        <div class="section-group" v-if="orderData.IsInvoice">
          <div class="section-group-title">发票信息</div>
          <van-cell-group>
            <van-field label="发票抬头">
              <template slot="input">
                <van-button :type="orderData.Invoice.Attribute === 1 ? 'danger' : 'default'" plain hairline size="mini"
                  class="btn-r" @click="changeInvoice(1)">个人</van-button>
                <van-button :type="orderData.Invoice.Attribute === 2 ? 'danger' : 'default'" plain hairline size="mini"
                  @click="changeInvoice(2)">企业</van-button>
              </template>
            </van-field>
            <van-field v-if="orderData.Invoice.Attribute === 1" v-model="orderData.Invoice.Header" label="个人姓名"
              placeholder="请输入" clearable />
            <van-field v-if="orderData.Invoice.Attribute === 2" v-model="orderData.Invoice.Header" clearable label="单位名称"
              placeholder="请填写单位名称" />
            <van-field v-if="orderData.Invoice.Attribute === 2" v-model="orderData.Invoice.TaxpayerNo" clearable
              label="单位税号" right-icon="question-o" placeholder="纳税人识别号或统一社会信用代码" />
            <van-field v-model="orderData.Invoice.Content" label="发票内容" disabled />
          </van-cell-group>
        </div>

        <div class="section-group" v-if="product.NeedContact">
          <div class="section-group-title">联系人信息</div>
          <van-cell-group>
            <van-field v-model="orderData.Contacts.Name" clearable label="姓名" placeholder="请填写姓名" />
            <van-field v-model="orderData.Contacts.Mobile" clearable label="手机号" placeholder="请填写手机号" />
            <van-field v-model="orderData.Contacts.Address" clearable label="地址" placeholder="请填写联系地址" />
          </van-cell-group>
        </div>
        <div style="height:20px;"></div>
      </div>
    </div>
    <div class="footer-box">
      <div class="red items">
        <span>￥</span>
        <span class="price">{{ sumPrice }}</span>
      </div>
      <div class="btns">
        <van-button round size="large" type="danger" class="btn-default" @click="submitOrder" :loading="payment"
          loading-text="提交中...">提交订单</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "checkout",
  //   props: ["goods", "product"],
  data () {
    return {
      payment: false,
      expressType: 1,
      product: {
        ProId: 0
      },
      addressInfo: {
        Detail: {},
        ExpressFee: 0
      },
      goods: {
        count: 1,
        skuId: 0,
        skuName: "",
        skuPrice: 0
      },
      orderData: {
        StockId: 0,
        Count: 0,
        AddressId: 0,
        Address: "",
        Name: "",
        Mobile: "",
        ExpressFee: 0,
        IsInvoice: true,
        ExpressType: 1,
        Source: "",
        Invoice: {
          Attribute: 1,
          Type: 1,
          Header: "个人",
          TaxpayerNo: "",
          Content: "",
          Remark: ""
        },
        Contacts: {
          Name: "",
          Mobile: "",
          Address: ""
        }
      }
    };
  },
  computed: {
    sumPrice: function () {
      return (
        Math.round(
          (this.orderData.ExpressFee + this.goods.skuPrice * this.goods.count) *
          100
        ) / 100
      );
    }
  },
  created () {
    //this.initDefaultAddress();
    //this.initData();
  },
  activated () {
    this.initData();
    //this.initDefaultAddress();
    this.changeAddress();
    this.expressType = 1;
  },
  watch: {
    expressType: function (newValue) {
      this.orderData.ExpressType = newValue;
      if (newValue === 2) {
        this.orderData.ExpressFee = 0;
      } else {
        //快递费
        this.orderData.ExpressFee = this.addressInfo.ExpressFee;
      }
    }
  },
  methods: {
    initData () {
      //console.log("init");
      this.goods.skuId = parseInt(this.$route.query.sku) || 0;
      this.goods.count = parseInt(this.$route.query.count) || 1;
      this.product.ProId = parseInt(this.$route.query.pid) || 0;
      this.orderData.StockId = this.goods.skuId;
      this.orderData.Count = this.goods.count;
      this.orderData.Source = this.$store.getters.source;

      let localProduct = localStorage.getItem("goods-info");
      if (localProduct) {
        let product = JSON.parse(localProduct);
        if (product.ProId === this.product.ProId) {
          //console.log(product);
          this.product = product;
          if (!this.product.EnableInvoice) {
            this.orderData.IsInvoice = false;
          }
          let sku = this.product.ProSkuList.find(
            s => s.StockId === this.goods.skuId
          );
          if (sku) {
            this.goods.skuName = sku.StockName;
            this.goods.skuPrice = sku.StockPrice;
          }
          //虚拟商品无运费
          // if (product.ProType === 2 || product.ProType === 3) {
          //   this.orderData.AddressId = 0;
          //   this.orderData.ExpressFee = 0;
          // } else {
          //   //初始化地址
          //   if (this.orderData.AddressId === 0) {
          //     //this.initDefaultAddress();
          //   }
          // }
        } else {
          //sku 变了
        }
      }
    },
    changeInvoice (type) {
      if (type !== this.orderData.Invoice.Attribute) {
        if (type === 1) {
          //个人
          this.orderData.Invoice.Attribute = 1;
          this.orderData.Invoice.Header = "个人";
          this.orderData.Invoice.TaxpayerNo = "";
        } else {
          //企业
          this.orderData.Invoice.Attribute = 2;
          this.orderData.Invoice.Header = "";
        }
      }
    },
    choiseAddress () {
      //console.log("选择地址");
      localStorage.removeItem("checkout_address-id");
      this.$router.push({
        path: "/address",
        query: { type: "checkout", addressId: this.orderData.AddressId }
      });
      this.orderData.AddressId = -1;
    },
    changeAddress () {
      //虚拟商品无地址
      if (this.product.ProType === 2 || this.product.ProType === 3) {
        this.orderData.AddressId = 0;
        this.orderData.ExpressFee = 0;
        this.addressInfo.ExpressFee = 0;
        return;
      }
      //选择地址后变更地址信息
      let addressId = localStorage.getItem("checkout_address-id");
      //console.log(addressId);
      let url = addressId
        ? "api/user/address/" + addressId
        : "api/user/address/default";

      //获取地址
      this.$ajax
        .get(url)
        .then(response => {
          if (response.data.code === 1) {
            let address = response.data.data;
            if (address) {
              this.addressInfo.Detail = address;
              this.addressInfo.ExpressFee =
                address.Province === "北京市" ? 15 : 15;

              this.orderData.AddressId = address.Id;
              this.orderData.Name = address.Recipient;
              this.orderData.Mobile = address.Mobile;
              this.orderData.Address = address.Address;

              this.orderData.ExpressFee =
                address.Province === "北京市" ? 15 : 15;
            } else {
              this.orderData.AddressId = 0;
              this.addressInfo.ExpressFee = 0;
            }
          } else {
            this.orderData.AddressId = 0;
            this.orderData.ExpressFee = 0;
            this.addressInfo.ExpressFee = 0;
          }
        })
        .catch(err => {
          console.log(err);
          this.orderData.AddressId = 0;
          this.orderData.ExpressFee = 0;
          this.addressInfo.ExpressFee = 0;
        });
    },
    initDefaultAddress () {
      //console.log(this.product);
      this.$ajax
        .get("api/user/address/default")
        .then(response => {
          if (response.data.code === 1) {
            let address = response.data.data;
            if (address) {
              this.addressInfo.Detail = address;
              this.addressInfo.ExpressFee =
                this.orderData.Address.indexOf("北京市") >= 0 &&
                  this.orderData.Address.indexOf("北京市") < 5
                  ? 15
                  : 15;

              this.orderData.AddressId = address.Id;
              this.orderData.Name = address.Recipient;
              this.orderData.Mobile = address.Mobile;
              this.orderData.Address = address.Address;

              this.orderData.ExpressFee =
                this.orderData.Address.indexOf("北京市") >= 0 &&
                  this.orderData.Address.indexOf("北京市") < 5
                  ? 15
                  : 15;
            } else {
              this.orderData.AddressId = 0;
            }
            this.loading = false;
          } else {
            this.orderData.AddressId = 0;
            this.orderData.ExpressFee = 0;
          }
        })
        .catch(err => {
          console.log(err);
          this.orderData.AddressId = 0;
          this.orderData.ExpressFee = 0;
        });
    },
    submitOrder () {
      if (
        this.orderData.AddressId <= 0 &&
        this.product.ProType === 1 &&
        this.orderData.ExpressType === 1
      ) {
        this.$toast("请选择地址");
        return;
      }
      //判断发票
      if (this.product.EnableInvoice && this.orderData.IsInvoice) {
        if (this.orderData.Invoice.Header === "") {
          this.$toast("请输入发票抬头");
          return;
        }
        if (this.orderData.Invoice.Attribute === 2) {
          if (this.orderData.Invoice.TaxpayerNo === "") {
            this.$toast("请输入纳税人识别号");
            return;
          }
        }
      }
      //判断联系人
      if (this.product.NeedContact) {
        if (this.orderData.Contacts.Name === "") {
          this.$toast("请输入联系人姓名");
          return;
        }
        if (this.orderData.Contacts.Mobile === "") {
          this.$toast("请输入联系人手机");
          return;
        }
        if (this.orderData.Contacts.Address === "") {
          this.$toast("请输入联系人地址");
          return;
        }
      }
      //提交订单
      this.payment = true;
      this.$ajax
        .post("/api/order/create/single", this.orderData)
        .then(response => {
          this.payment = false;
          if (response.data.code === 1) {
            //success
            if (response.data.data.PayUrl === "") {
              //预约
              this.$router.push({ path: "/order/0" });
            } else {
              this.$toast.loading({
                mask: true,
                message: "跳转支付",
                forbidClick: true
              });
              window.location.href = response.data.data.PayUrl;
            }
          } else {
            //this.$toast.fail(response.data.message);
            this.$dialog
              .alert({
                title: "下单失败",
                message: response.data.message
              })
              .then(() => {
                // on close
              });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/base-var.less";

.goods-box {
  display: flex;
  background: #fff;
  padding: 10px 15px;
  font-size: 16px;
}

.goods-box .image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.goods-box .image img {
  max-width: 100%;
  border-radius: 4px;
}

.goods-box .info {
  flex: 1;
}

.info-item {
  display: flex;
  margin-bottom: 5px;
}

.info-item-right {
  width: 60px;
  text-align: right;
}

.info-item-left {
  flex: 1;
  text-align: left;
}

.p-title {
  font-weight: 500;
}

.p-price {
  color: #f44;
}

.sku-f {
  font-size: 12px;
  color: @gray-color;
}

.invoice-box {
  padding: 10px 0;
  background-color: #fff;
}
</style>